import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Analytics from './Analytics';
import './App.scss';
import { Maintenance } from './Maintenance';
import { AppRouter, AuthRouter } from './routing';
import { RootProvider, rootStore } from './stores';

function App() {
  return (
    <RootProvider value={rootStore}>
      <BrowserRouter>
        <Switch>
          <Route path="/auth" component={AuthRouter} />
          <Route path="/maintenance" component={Maintenance} />
          <Route path="*" component={AppRouter} />
        </Switch>
        <Analytics />
      </BrowserRouter>
    </RootProvider>
  );
}

export default App;
